import { SetVariablesAction } from '@/shared/types/action';
import { addDollarSign } from '@/util/util';

const SetVariables = ({ action }: { action: SetVariablesAction }) => {
  const { variables } = action;
  // The second condition prevents the text from showing up when the user
  // has opened the dropdown and has not yet selected a variable
  return variables?.length && variables?.[0]?.variable ? (
    <span className="text-sm leading-5 font-normal break-words text-muted-foreground">
      {addDollarSign(variables?.[0]?.variable)}
    </span>
  ) : null;
};

export default SetVariables;
